package ui.component.switches

import emotion.react.css
import react.FC
import react.Props
import react.dom.html.ReactHTML
import ui.styles.icons.CloseRoundedIconSVG
import ui.styles.icons.IconsSVG
import web.cssom.*
import web.html.InputType

external interface SwitchMassiveProps:Props {
    var titleTextOrNull:String?
    var titleTextForTitle:String?
    var heightSize: Int?
    var switchIcon: IconsSVG
    var checked: Boolean
    var onChange: () -> Unit
}

var SwitchMassive = FC <SwitchMassiveProps>{props->
    val titleText = when(props.titleTextOrNull){
        undefined->null
        else->props.titleTextOrNull
    }
    val titleTextForTitle = when(props.titleTextForTitle){
        undefined->null
        else->props.titleTextForTitle
    }
    val heightSize = when(props.heightSize){
        undefined->100
        null->100
        else->props.heightSize
    }
    val switchIcon = props.switchIcon.takeIf { it != undefined } ?: CloseRoundedIconSVG
    val checkedBoolean = props.checked.takeIf { it != undefined } ?: false
    val onChangeUnit = props.onChange.takeIf { it != undefined } ?: {}

    ReactHTML.div{

        title = titleTextForTitle

        css {
            maxWidth = 100.pct
            display = Display.flex
            justifyContent = JustifyContent.center
            flexDirection = FlexDirection.column
            alignItems = AlignItems.center
        }

        if (titleText != null){
            ReactHTML.span{

                className = ClassName("switch_massive_title")

                +titleText//"Выбрана ${theme.icon.description}"
            }
        }

        ReactHTML.input{
            id = "switch_massive"

            type = InputType.checkbox

            checked = checkedBoolean//theme == ThemesMode.DARK

            onChange = {
                onChangeUnit()
            }

        }
        ReactHTML.label{
            className = ClassName("label_switch_massive")
            css(this.className) {
                this[CustomPropertyName("--lb-switch-base")] = heightSize
                this[CustomPropertyName("--lb-switch-height")] = this[CustomPropertyName("--lb-switch-base")].toString().toInt().px
            }
            htmlFor = "switch_massive"

            +"Toggle"
            ReactHTML.div{
                className = ClassName("switch_massive_btn")

                css(this.className) {

                }

                switchIcon.iconSVG()
            }
        }
    }


}